import React, { useEffect, useState } from 'react'

const formatTime = (seconds: number) => {
	const h = Math.floor(seconds / 3600)
	const m = Math.floor((seconds % 3600) / 60)
	const s = Math.round(seconds % 60)
	return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s].filter(Boolean).join(':')
}

export const Timer = ({ timestamp, onTimerEnd }: { timestamp: number; onTimerEnd(): void }) => {
	const [secondsLeft, setSecondsLeft] = useState<number | null>(null)
	useEffect(() => {
		if (!timestamp) {
			return undefined
		}
		setSecondsLeft(Math.floor((timestamp - new Date().getDate()) / 1000))
		const interval = setInterval(() => {
			setSecondsLeft((cur) => {
				if (cur! - 1 === 0) {
					clearInterval(interval)
					setTimeout(onTimerEnd)
					return null
				}

				return cur! - 1
			})
		}, 1000)

		return () => {
			clearInterval(interval)
		}
	}, [timestamp])

	return <>{secondsLeft && formatTime(secondsLeft)}</>
}
